// @flow
import {
  GET_DATA,
  ADD,
  UPDATE,
  DELETE,
  SET_INITIALIZED_DATA,
  ADD_SELECTED_ROW,
  DELETE_SELECTED_ROW,
  SET_SELECTED_ROWS,
  SET_FILTERS,
  SET_SORTERS,
  GET_CATEGORIES,
} from "../actions/news";

let defaultSorters = {
  "date": "desc", 
  "priority": "asc",
};

let dataState = { 
  // Common
  data: [], count: 0, limit: 25,
  initializedData: false,
  selectedRows: [],
  filters: {},
  sorters: defaultSorters,
  initialSorters: defaultSorters,
  // Searcher
  searcher_selectedRows: [],
  searcher_filters: {},
  searcher_sorters: {},
  // Others
  categories: [],
};

const NewsReducer = (state = dataState, action) => {
  let newdata, index;

  switch (action.type) {
    case GET_DATA:
      // Paginated API: { data, count, limit }
      if (action.payload && Array.isArray(action.payload.data)) {
        return {
          ...state,
          data: action.payload.data,
          count: Number(action.payload.count) || 0,
          limit: Number(action.payload.limit) || state.limit || 25,
        };
      }
      // Legacy non-paginated array (should not happen once backend is updated)
      if (Array.isArray(action.payload)) {
        const limit = state.limit || 25;
        return {
          ...state,
          data: action.payload.slice(0, limit),
          count: action.payload.length,
          limit,
        };
      }
      return state;

    case ADD:
      return {
        ...state,
        data: [action.payload, ...state.data],
        count: (state.count || 0) + 1,
      };

    case UPDATE:
      const newArray = [...state.data];
      index = state.data.findIndex((object) => {
        return object.id === action.id;
      });
      if (index !== -1) {
        newArray[index] = action.payload;
      }
      return {
        ...state,
        data: newArray,
      };

    case DELETE:
      return {
        ...state,
        data: state.data.filter((el) => el.id !== action.id),
        count: Math.max(0, (state.count || 0) - 1),
      };

    case SET_INITIALIZED_DATA:
      newdata = Object.assign({}, state);
      newdata.initializedData = action.payload;
      state = Object.assign({}, state, newdata);
      return state;

    case ADD_SELECTED_ROW:
      if (action.isSearcher) {
        return {
          ...state,
          searcher_selectedRows: [...state.searcher_selectedRows, action.payload],
        };
      } else {
        return {
          ...state,
          selectedRows: [...state.selectedRows, action.payload],
        };
      }

    case DELETE_SELECTED_ROW:
      if (action.isSearcher) {
        return {
          ...state,
          searcher_selectedRows: state.searcher_selectedRows.filter((el) => el.id !== action.id),
        };  
      } else {
        return {
          ...state,
          selectedRows: state.selectedRows.filter((el) => el.id !== action.id),
        };  
      }
      
    case SET_SELECTED_ROWS:
      newdata = Object.assign({}, state);
      if (action.isSearcher) {
        newdata.searcher_selectedRows = action.payload;
      } else {
        newdata.selectedRows = action.payload;
      }
      state = Object.assign({}, state, newdata);
      return state;

    case SET_FILTERS:
      newdata = Object.assign({}, state);
      if (action.isSearcher) {
        newdata.searcher_filters = action.payload;
      } else {
        newdata.filters = action.payload;
      }
      state = Object.assign({}, state, newdata);
      return state;

    case SET_SORTERS:
      newdata = Object.assign({}, state);
      if (action.isSearcher) {
        newdata.searcher_sorters = action.payload;
      } else {
        newdata.sorters = action.payload;
      }
      state = Object.assign({}, state, newdata);
      return state;

    case GET_CATEGORIES:
      newdata = Object.assign({}, state);
      newdata.categories = action.payload;
      state = Object.assign({}, state, newdata);
      return state;

    default:
      return state;
  }
};

export default NewsReducer;
